<template>
  <v-container fluid>
    <PageHeading
      :text="'Отели'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-col cols='6'>
          <v-btn
            link
            small
            outlined
            color="primary"
            class="mx-2 mt-2"
            :to="{
              name: 'page-hotel-new'
            }"
          >
            <v-icon
              class="mr-2"
              small
            >
              mdi-plus
            </v-icon>
            Создать отель
          </v-btn>
        </v-col>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridHotels ref="grid"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridHotels from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageHotels',
  components: {
    PageHeading,
    GridHotels
  },
  metaInfo () {
    return {
      title: 'Отели'
    }
  },
  mixins: [gridPageInterface],
  data () {
    return {
      totalCount: 0
    }
  },
  methods: {
    createHotel () {
      this.$router.push({ name: 'page-hotel-new' })
    }
  }
}
</script>
